export default IconBrandLinktree => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-linktree" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 10h16" />
  <path d="M6.5 4.5l11 11" />
  <path d="M6.5 15.5l11 -11" />
  <path d="M12 10v-8" />
  <path d="M12 15v7" />
</svg>`;